import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody29';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy29 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'> Optimizing the Development Stage-  </h2><h4>Gate Process for a Real Estate company</h4>";

  return (
    <>
        <Helmet>
        <title>Optimizing the Development Stage-Gate Process for a Real Estate company</title>
        <meta property="og:title" content="Optimizing the Development Stage-Gate Process for a Real Estate company" />
        <meta property='og:description' content='Optimizing the Development Stage-Gate Process for a Real Estate company'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy29" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy29
